import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=24dbf0d4&scoped=true"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbf0d4",
  null
  
)

export default component.exports